require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-pn-2-yh.json") })
        }
      }, "path---photos-professional-pn-2-yh");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-pn-2-yh!./.cache/json/photos-professional-pn-2-yh.json
// module id = 867
// module chunks = 231608221292675